import {jsPDF} from 'jspdf';
import html2canvas from 'html2canvas';

export const createPDF = (htmlContent, fileName, canvasOptions = {scale: 2}) => {
  html2canvas(htmlContent,canvasOptions).then(function(canvas) {
    let canvasWidth = canvas.width;
    let canvasHeight = canvas.height;
    const img = canvas.toDataURL("image/jpeg", canvasWidth, canvasHeight); //image data of canvas
    const topLeftMargin = 15;
    const PDFWidth = canvasWidth+(topLeftMargin*2);
    const PDFHeight = (PDFWidth*1.5)+(topLeftMargin*2);
    const totalPages = Math.ceil(canvasHeight/PDFHeight) -1;
    const doc = new jsPDF('p','pt',[PDFWidth, PDFHeight]);
    doc.addImage(img, "JPEG", topLeftMargin, topLeftMargin, canvasWidth, canvasHeight);
    for(let i = 1; i<= totalPages; i++){
      doc.addPage([PDFWidth, PDFHeight]);
      doc.addImage(img, "JPEG", topLeftMargin, -(PDFHeight*i)+(topLeftMargin*4), canvasWidth, canvasHeight)
    }
    doc.save(`${fileName}.pdf`);
  });
}
